import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

const NumberRange = ({
    title='Khoảng giá trị',
    labelStart = 'Giá trị bắt đầu',
    labelEnd = 'Giá trị kết thúc',
    startValue = '',
    endValue = '',
    onChangeStart,
    onChangeEnd,
    // containerClassName = 'card card-default',
    containerClassName = '',
    // rowClassName = 'card-body row',
    rowClassName = 'row p-0',
    startColClassName = 'col-sm-6',
    endColClassName = 'col-sm-6',
    min = '',
    max = '',
    maxLength = '',
    options = []
}) => {
    const [startListId] = useState(() => `start_options_list_${uuidv4()}`);
    const [endListId] = useState(() => `end_options_list_${uuidv4()}`);
    
    return (
        <div className={containerClassName}>
            <label className='text-bold'>{title}</label>
            <div className={rowClassName}>
                <div className={startColClassName}>
                    <div style={{width: '100%'}}>
                        <div className="form-group">
                            <label>{labelStart}</label>
                            <input
                                type="number"
                                className="form-control"
                                name={'start_value'}
                                value={startValue}
                                onChange={onChangeStart}
                                placeholder="Nhập giá trị bắt đầu"
                                autoComplete="off"
                                min={min}
                                max={max}
                                maxLength={maxLength}
                                list={options.length > 0 ? startListId : null}
                            />
                            {options.length > 0 && (
                                <datalist id={startListId}>
                                    {options.map((option, index) => (
                                        <option key={index} value={option} />
                                    ))}
                                </datalist>
                            )}
                        </div>
                    </div>
                </div>
                <div className={endColClassName}>
                    <div style={{width: '100%'}}>
                        <div className="form-group">
                            <label className={'w-100'}><b>{labelEnd}</b></label>
                            <input
                                type="number"
                                className="form-control"
                                name={'end_value'}
                                value={endValue}
                                onChange={onChangeEnd}
                                placeholder="Nhập giá trị kết thúc"
                                autoComplete="off"
                                min={min}
                                max={max}
                                maxLength={maxLength}
                                list={options.length > 0 ? endListId : null}
                            />
                            {options.length > 0 && (
                                <datalist id={endListId}>
                                    {options.map((option, index) => (
                                        <option key={index} value={option} />
                                    ))}
                                </datalist>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NumberRange;
